import { useCallback, useEffect, useState } from "react";

export const isDocumentPortalMode = (mode) => mode === "documentPortal";

/**
 * The capability is backward compatible: only an explicit "false" disables it.
 * Document portals always disable it, regardless of stale or missing query params.
 */
export const parseChatWithDocsEnabled = (value, mode) =>
  !isDocumentPortalMode(mode) && value !== "false";

export const normalizeCompareGuidelinesMode = (compareMode, mode) =>
  !isDocumentPortalMode(mode) && compareMode === true;

export const useChatWithDocsCapability = (rawCapability, mode) => {
  const isChatWithDocsEnabled = parseChatWithDocsEnabled(rawCapability, mode);
  const [isChatWithDocsOpen, setIsChatWithDocsOpen] = useState(false);

  useEffect(() => {
    if (!isChatWithDocsEnabled) {
      setIsChatWithDocsOpen(false);
    }
  }, [isChatWithDocsEnabled]);

  const openChatWithDocs = useCallback(() => {
    if (!isChatWithDocsEnabled) {
      return false;
    }

    setIsChatWithDocsOpen(true);

    return true;
  }, [isChatWithDocsEnabled]);

  const closeChatWithDocs = useCallback(() => {
    setIsChatWithDocsOpen(false);
  }, []);

  return {
    isChatWithDocsEnabled,
    isChatWithDocsOpen,
    openChatWithDocs,
    closeChatWithDocs,
  };
};
